import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';
import { CellIds } from 'constants/grid';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

LicenseManager.setLicenseKey(
  'CompanyName=LUMBRELA d. o. o.,LicensedApplication=Tickmark Reporting tool,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-034890,SupportServicesEnd=7_January_2024_[v2]_MTcwNDU4NTYwMDAwMA==d2f922ed323405b8c539523c986f2478'
);

const baseStyle = {
  font: {
    color: '#000000',
    fontName: 'Arial Regular',
    size: 10,
  },
};
const defaultExcelStyles = [
  {
    ...baseStyle,
    id: CellIds.header,
    interior: {
      color: '#DEDEDE',
      pattern: 'Solid',
    },
  },
  {
    ...baseStyle,
    id: CellIds.default,
  },
  {
    ...baseStyle,
    id: CellIds.numeric,
    numberFormat: {
      format: '#,##0.00',
    },
  },
  {
    ...baseStyle,
    id: CellIds.string,
    dataType: 'string',
  },
];

const sizeColumns = ({ api }) => {
  api.sizeColumnsToFit();
  window.onresize = api.sizeColumnsToFit();
};

export const Grid = ({
  defaultColDef = {},
  excelStyles = [],
  ...otherProps
}) => {
  let cellClass = defaultColDef.cellClass || CellIds.default;
  if (Array.isArray(cellClass)) {
    if (!cellClass.includes(CellIds.default)) {
      cellClass.push(CellIds.default);
    }
  } else if (cellClass !== CellIds.default) {
    cellClass = [cellClass, CellIds.default];
  }

  return (
    <div className="ag-wrapper ag-theme-balham">
      <AgGridReact
        groupDefaultExpanded={-1}
        suppressMovableColumns={true}
        suppressDragLeaveHidesColumns={true}
        onGridReady={sizeColumns}
        deltaRowDataMode={true}
        getRowNodeId={(d) => d.id}
        allowContextMenuWithControlKey={true}
        sideBar={{
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivotMode: true,
              },
            },
          ],
          position: 'right',
        }}
        defaultColDef={{
          sortable: true,
          resizable: true,
          suppressMenu: true,
          ...defaultColDef,
          cellClass,
        }}
        excelStyles={[...defaultExcelStyles, ...excelStyles]}
        {...otherProps}
      />
    </div>
  );
};
